import React, { useEffect } from "react";
import Metatag from "../../components/Metatag/Metatag";

const ElectricalSolutions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Metatag
        title="Complete Electrical Solutions | DEWA Approved Contractor"
        description="Megavolt provides end-to-end electrical solutions in Dubai. From HV/LV systems to fast-track DEWA approvals. Dependable MEP works by a DEWA approved contractor."
        link="electricalsolutions"
      />
      <div>
        <div className="text-center items-center mb-10 mt-10">
          <h1 className="text-[34px] font-semibold text-[black]">
            Complete Electrical <span className="text-[#ffb732] text-[38px]">Solutions</span>
          </h1>
          <p className="mt-3 text-lg font-medium text-gray-700 px-4">
            Reliable engineering, smart planning & formal DEWA approvals
          </p>
        </div>

        <div className="flex-col flex lg:flex-row gap-[19px] sm:gap-10 lg:justify-around sm:w-[85%] sm:mx-auto p-4 mb-20 relative">
          <div className="rounded-xl w-full border-t-[2px] border-[#cbcbcb] lg:p-10 p-5 bg-white" style={{ boxShadow: '0px 2px 25px #7c78754f' }}>
            <p className="text-[#090a0e] text-lg leading-loose mb-6 text-justify">
              At <strong>Megavolt Technical Services Co. LLC</strong>, we combine top-tier technical expertise with streamlined administrative support. As an established <strong>DEWA approved contractor</strong> in Dubai, we are your one-stop-shop for complete electrical solutions—tailoring designs, handling execution, and guaranteeing finalized <strong>DEWA approvals</strong>.
            </p>
            <p className="text-[#090a0e] text-lg leading-loose mb-8 text-justify">
              We serve residential buildings, retail fit-outs, luxury villas, and large-scale industrial warehouses. Whether securing new power connections, designing highly specialized Earthing & Lightning systems, or ensuring swift fit-out commissioning, we build solutions that last and add long-term value.
            </p>



            <div className="bg-gray-50 border-l-4 border-[#ffb732] p-6 mb-10 text-[#090a0e]">
              <h3 className="font-bold text-2xl mb-3">Seamless DEWA Approvals</h3>
              <p className="mb-2">We recognize the complexities of adhering to municipal regulations. Hiring an uncertified team can result in rejected applications and project deadlocks. Partnering with Megavolt—a dedicated <strong>DEWA approved contractor</strong>—ensures your electrical solutions are built right the first time, securing fast <strong>DEWA approvals</strong> to keep your project on schedule and budget.</p>
            </div>

            <div className="text-center bg-[#f9f9f9] border border-gray-300 p-8 rounded-lg shadow-inner">
              <h2 className="text-[#ffb732] text-3xl font-bold mb-4">Partner with the Best in Dubai</h2>
              <p className="text-[#090a0e] text-lg leading-loose mb-4">
                Bring your concept to life with our comprehensive project lifecycle support. End-to-end engineering, commissioning, and verified <strong>DEWA approvals</strong>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ElectricalSolutions;
